import close from "./close.svg";

export default function CloseIcon() {
  return (
    <img src={close} />
  );
}